import { Form, Formik } from 'formik';
import { Props, Values } from './UserTask.types';
import * as Yup from 'yup';
import FormField from '../../components/field/FormField';
import Button from '../../components/button/Button';
import { useTranslation } from '../../context/translationContext';
import { useCurrentCompany } from '../../hooks/useCompany';
import { Loader } from '../../components/loader/Loader';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../pages/RouterContainer';

/**
 *  Form component for creating / editing user tasks
 */
export const UserTaskForm = ({ onSubmit, initialValues }: Props) => {
  const { t } = useTranslation();
  const { company } = useCurrentCompany();
  const navigate = useNavigate();

  const _initialValues: Values = {
    companyId: undefined,
    name: '',
    description: '',
  };

  const UserTaskSchema = Yup.object().shape({
    name: Yup.string().required('Task name is required.'),
  });

  if (!company) return <Loader />;
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={UserTaskSchema}
    >
      {({ errors, touched }) => (
        <Form className="w-full text-center">
          <div className="my-4">
            <FormField
              id="name"
              name="name"
              label={t('page.user-task.input-name')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              id="description"
              name="description"
              label={t('page.user-task.input-description')}
              rows={4}
              multiline={true}
              component={'textarea'}
              errors={errors}
              touched={touched}
            />
          </div>

          <div className="flex float-left">
            <Button
              title={t('general.back')}
              color="gray"
              className="mr-3"
              onClick={() => navigate(`/${paths.USER_TASKS}`)}
            />
            <Button title={t('general.save')} color="green" type="submit" showLoading />
          </div>
        </Form>
      )}
    </Formik>
  );
};
